import { FC } from 'react';

import { DocusignIcon } from '../../../../assets/icons/docusign-icon';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { Tooltip } from '../../../../components/tooltip/index';
import { useLocale } from '../../../../hooks/use-locale.hook';

type BrowserFileTypeProps = { isDocusignSynced?: boolean };

// What the Type column says of a file: "File", and for a document synced from DocuSign the
// DocuSign mark after it, with a tooltip naming it.
export const BrowserFileType: FC<BrowserFileTypeProps> = ({ isDocusignSynced = false }) => {
  const { messagesLocale } = useLocale();

  return (
    <span className="inline-flex items-center gap-2">
      <AppFormattedMessage id="FILE" />
      {isDocusignSynced && (
        <Tooltip content={<AppFormattedMessage id="DOCUSIGN_SYNCED" />}>
          <DocusignIcon
            aria-label={messagesLocale['DOCUSIGN_SYNCED']}
            className="size-3"
            role="img"
          />
        </Tooltip>
      )}
    </span>
  );
};
